import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listNotes, createNote, deleteNote } from '@/api/notes';
import type { CreateNoteInput } from '@/types/note';

export function useNotes(studentId: string) {
  return useQuery({
    queryKey: ['teachers', 'notes', studentId],
    queryFn: () => listNotes(studentId),
    enabled: !!studentId,
  });
}

export function useCreateNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateNoteInput) => createNote(input),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['teachers', 'notes', variables.student_id] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'students', variables.student_id] });
    },
  });
}

export function useDeleteNote(studentId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (noteId: string) => deleteNote(noteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teachers', 'notes', studentId] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'students', studentId] });
    },
  });
}
